import React, { useContext } from "react";

import { DrawerContext } from "../context/Drawer";
import { Box } from "../components/elements/Box";

export function Main({ children, style }) {
  const { drawer } = useContext(DrawerContext);
  return (
    <Box as="main" className={`mc-main ${drawer ? "active" : ""}`} style={style}>
      {children}
    </Box>
  );
}
